module.exports = __webpack_public_path__ + "static/logo-fb64a874654259ea1cdaed975a8c3734.svg";